import { render } from "./Sidebar2.vue?vue&type=template&id=7c6b03a4&scoped=true"
import script from "./Sidebar2.vue?vue&type=script&lang=js"
export * from "./Sidebar2.vue?vue&type=script&lang=js"

import "./Sidebar2.vue?vue&type=style&index=0&id=7c6b03a4&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6b03a4"]])

export default __exports__